import { atom } from "recoil";

export const createSourceDrawerState = atom({
    key: "createSourceDrawerState", // unique ID (with respect to other atoms/selectors)
    default: null, // default value (aka initial value) 
})